import React, { useState, useEffect } from 'react';
import Paper from '@material-ui/core/Paper';
import { makeStyles } from '@material-ui/core/styles';
import { Avatar, Typography } from '@material-ui/core';
import Pagination from '@material-ui/lab/Pagination';
import { Link, withRouter } from 'react-router-dom'
import NewsRightSideBar from './NewsRightSideBar';
import config from '../../../config/config.json';

const useStyles = makeStyles((theme) => ({
    root: {
        height: 180,
    },
    wrapper: {
        width: 100 + theme.spacing(2),
    },
    paper: {
        zIndex: 1,
        position: 'relative',
        margin: theme.spacing(1),
        padding: theme.spacing(5)
    },
    svg: {
        width: 100,
        height: 100,
    },
    polygon: {
        fill: theme.palette.common.white,
        stroke: theme.palette.divider,
        strokeWidth: 1,
    },
}));

function News({ lang, match }) {
    const classes = useStyles();
    const [elevation, setElevation] = useState(0);
    const [noticias, setNoticias] = useState([]);
    const [categorias, setCategorias] = useState([]);
    const [page, setPage] = useState(1);
    const perPage = 4;

    useEffect(() => {
        window.scrollTo(0, 1);
    }, []);

    useEffect(() => {
        let url = (match.params.category) ?
            `${config.apiBaseUrl}/noticias/categoria/${match.params.category}`
            : `${config.apiBaseUrl}/noticias`;

        // obteniendo las noticias
        fetch(url)
            .then(
                res => {
                    return res.json();
                }
            )
            .then(
                data => {
                    console.log('noticias => ', data);
                    setNoticias(data);
                }
            )
            .catch(
                err => {
                    console.log("news error ", err);
                }
            );

        // obteniendo categorias de noticias
        url = `${config.apiBaseUrl}/categorias`;
        fetch(url)
            .then(
                res => {
                    return res.json();
                }
            )
            .then(
                data => {
                    console.log('categorias => ', data);
                    setCategorias(data);
                }
            )
            .catch(
                err => {
                    console.log('category error: ', err);
                }
            );

        // cleanup
        return () => {
        }
    }, []);

    const NoticiasComponent = noticias.map((noticia, i) => {
        if ((page - 1) * perPage <= i && i < page * perPage) {
            return (
                <React.Fragment key={i}>
                    <div className="row">
                        <div className="col-md-4 col-sm-4">
                            <img className="img-responsive" alt="" src={noticia.foto} />
                        </div>
                        <div className="col-md-8 col-sm-8">
                            <h2><Link to={"/new/" + noticia.nombre}>{noticia.titulo}</Link></h2>
                            <ul className="blog-info">
                                <li><i className="fa fa-user"></i> {noticia.autor} </li>
                                <li><i className="fa fa-calendar"></i> {noticia.fecha}</li>
                                <li><a href={"/news/category/" + noticia.categoria_slug}><i className="fa fa-folder-o"></i> {noticia.categoria} </a></li>
                                {/* <li><i className="fa fa-comments"></i> 17</li> */}
                                {/* <li><i className="fa fa-tags"></i> Metronic, Keenthemes, UI Design</li> */}
                            </ul>
                            <p>{noticia.texto}</p>
                            <Link to={"/new/" + noticia.nombre} className="more">Leer mas <i className="icon-angle-right"></i></Link>
                        </div>
                    </div>
                    <hr className="blog-post-sep" />
                </React.Fragment>
            )
        }
    });

    // categorias
    const CategoriasComponent = Object.values(categorias).map((categoria, index) => (
        <React.Fragment key={index}>
            <li /* className="active" */>
                <a href={"/news/category/" + categoria.slug}>{categoria.categoria} ({categoria.cantidad_noticias})</a>
            </li>
        </React.Fragment>
    ));

    const getIniciales = (autor) => {
        const autorArr = autor.split(' ');

        const n = autorArr[0][0].toLowerCase();
        let n1, ap1, ap2;
        if (autorArr.length == 3) {
            n1 = '';
            ap1 = autorArr[1][0].toLowerCase();
            ap2 = autorArr[2][0].toLowerCase();
        } else if (autorArr.length == 4) {
            n1 = autorArr[1][0].toLowerCase();
            ap1 = autorArr[2][0].toLowerCase();
            ap2 = autorArr[3][0].toLowerCase();
        }

        return n + n1 + ap1 + ap2;
    }
    // noticias recientes tomar las 3 1ras
    let RecientesComponent = [];
    for (const i in noticias) {
        if (i < 3) {
            RecientesComponent[i] =
                <div className="row margin-bottom-10" key={i}>
                    <div className="col-md-3">
                        <Avatar alt={noticias[i].autor} src={`./assets/files/avatar/all_trab/${getIniciales(noticias[i].autor)}.png`} className={classes.xl} />
                    </div>
                    <div className="col-md-9 recent-news-inner">
                        <h3><a href="#">{noticias[i].titulo}</a></h3>
                        <p>{noticias[i].texto.substring(0, 51)}...</p>
                    </div>
                </div>
        }
    }

    // Pagination
    const handlePaginationChange = (event, value) => {
        setPage(value);
    }

    return (
        <section id="news">
            <div className="features-bg">
                <div className="container">
                    <div className="heading">
                        <h2><strong>Noticias</strong></h2>
                    </div>
                    <Paper elevation={elevation} className={classes.paper} onMouseOver={() => setElevation(10)} onMouseOut={() => setElevation(0)}>
                        <div className="row">
                            {/* BEGIN LEFT SIDEBAR */}
                            <div className="col-md-9 col-sm-9 blog-posts">

                                {NoticiasComponent}

                                <Pagination count={Math.ceil(noticias.length / perPage)} page={page} onChange={handlePaginationChange} /* variant="outlined" */ shape="rounded" color="primary" />
                                {/* <ul className="pagination">
                                    <li><a href="#">Anterior</a></li>
                                    <li><a href="#">1</a></li>
                                    <li><a href="#">2</a></li>
                                    <li className="active"><a href="#">3</a></li>
                                    <li><a href="#">4</a></li>
                                    <li><a href="#">5</a></li>
                                    <li><a href="#">Siguiente</a></li>
                                </ul> */}
                            </div>
                            {/* END LEFT SIDEBAR */}

                            {/* BEGIN RIGHT SIDEBAR */}
                            <NewsRightSideBar />
                            {/* END RIGHT SIDEBAR */}
                        </div>
                    </Paper>
                </div>
            </div>
        </section>
    );
}

export default withRouter(News);